import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";

export interface Menu {
  state: string;
  name: string;
  type: string;
  iconUrl: string;
  iconUrlActive: string;
}

const MENUITEMS = [
  {
    state: "dashboard",
    name: "Dashboard",
    type: "link",
    iconUrl: "assets/images/ic_dashboard.svg",
    iconUrlActive: "assets/images/ic_dashboard_active.svg",
    access: "all",
  },
  {
    state: "user",
    name: "Users",
    type: "link",
    iconUrl: "assets/images/ic_user.svg",
    iconUrlActive: "assets/images/ic_user_active.svg",
    access: "admin",
  },
  {
    state: "school",
    name: "Institutions",
    type: "link",
    iconUrl: "assets/images/school.png",
    iconUrlActive: "assets/images/school.png",
    access: "admin",
  },
  // { state:'manager', name: 'Managers', type: 'link',  iconUrl: "assets/images/server_black.svg", iconUrlActive: "assets/images/server_white.svg", access: 'all'},
  {
    state: "scholarship",
    name: "Scholarships",
    type: "link",
    iconUrl: "assets/images/ic_invoice.svg",
    iconUrlActive: "assets/images/ic_invoice_active.svg",
    access: "all",
  },
  {
    state: "settings",
    name: "Criteria",
    type: "link",
    iconUrl: "assets/images/criteria.svg",
    iconUrlActive: "assets/images/criteria_active.svg",
    access: "all",
  },
  {
    state: "scholarship-app",
    name: "Scholarship Applications",
    type: "link",
    iconUrl: "assets/images/ic_merchant.svg",
    iconUrlActive: "assets/images/ic_merchant_active.svg",
    access: "all",
  },
  // {
  //   state: "application",
  //   name: "Application",
  //   type: "link",
  //   iconUrl: "assets/images/ic_merchant.svg",
  //   iconUrlActive: "assets/images/ic_merchant_active.svg",
  //   access: "all",
  // },
  // { state:'item', name: 'Items', type: 'link', iconUrl: 'assets/images/ic_dashboard.svg',iconUrlActive: 'assets/images/ic_dashboard_active.svg', access: 'users'},
  // { state: 'profile', type: 'link', name: 'Manage Profile',iconUrl: 'assets/images/ic_user1.svg',iconUrlActive: 'assets/images/ic_user1_active.svg', access: 'users' },
  //  { state: 'order', type: 'link', name: 'Order',iconUrl: 'assets/images/ic_order.svg',iconUrlActive: 'assets/images/ic_order_active.svg', access: 'drivers' },
  //  { state: 'promo', type: 'link', name: 'Manage Coupon',iconUrl: 'assets/images/ic_promo.svg',iconUrlActive: 'assets/images/ic_promo_active.svg', access: 'users' },
  //  { state: 'menu', type: 'link', name: 'Manage Menu',iconUrl: 'assets/images/ic_menu.svg',iconUrlActive: 'assets/images/ic_menu_active.svg', access: 'users' },
  //  { state: 'category', type: 'link', name: 'Manage Category',iconUrl: 'assets/images/ic_list.svg',iconUrlActive: 'assets/images/ic_list_active.svg', access: 'users' },
  //  { state: 'feedback', type: 'link', name: 'Feedback',iconUrl: 'assets/images/ic_feedback.svg',iconUrlActive: 'assets/images/ic_feedback_active.svg', access: 'users' },
];
const MENUITEMSMANAGER = [
  {
    state: "scholarship",
    name: "Scholarship",
    type: "link",
    iconUrl: "assets/images/ic_invoice.svg",
    iconUrlActive: "assets/images/ic_invoice_active.svg",
    access: "all",
  },
  // { state:'item', name: 'Items', type: 'link', iconUrl: 'assets/images/ic_dashboard.svg',iconUrlActive: 'assets/images/ic_dashboard_active.svg', access: 'users'},
  // { state: 'profile', type: 'link', name: 'Manage Profile',iconUrl: 'assets/images/ic_user1.svg',iconUrlActive: 'assets/images/ic_user1_active.svg', access: 'users' },
  //  { state: 'order', type: 'link', name: 'Order',iconUrl: 'assets/images/ic_order.svg',iconUrlActive: 'assets/images/ic_order_active.svg', access: 'drivers' },
  //  { state: 'promo', type: 'link', name: 'Manage Coupon',iconUrl: 'assets/images/ic_promo.svg',iconUrlActive: 'assets/images/ic_promo_active.svg', access: 'users' },
  //  { state: 'menu', type: 'link', name: 'Manage Menu',iconUrl: 'assets/images/ic_menu.svg',iconUrlActive: 'assets/images/ic_menu_active.svg', access: 'users' },
  //  { state: 'category', type: 'link', name: 'Manage Category',iconUrl: 'assets/images/ic_list.svg',iconUrlActive: 'assets/images/ic_list_active.svg', access: 'users' },
  //  { state: 'feedback', type: 'link', name: 'Feedback',iconUrl: 'assets/images/ic_feedback.svg',iconUrlActive: 'assets/images/ic_feedback_active.svg', access: 'users' },
];
const MENUITEMSCHOOL = [
  {
    state: "dashboard",
    name: "Dashboard",
    type: "link",
    iconUrl: "assets/images/ic_dashboard.svg",
    iconUrlActive: "assets/images/ic_dashboard_active.svg",
  },
  {
    state: "user",
    name: "Users",
    type: "link",
    iconUrl: "assets/images/ic_user.svg",
    iconUrlActive: "assets/images/ic_user_active.svg",
  },
  {
    state: "scholarship",
    name: "Scholarship",
    type: "link",
    iconUrl: "assets/images/ic_invoice.svg",
    iconUrlActive: "assets/images/ic_invoice_active.svg",
  },
  {
    state: "application",
    name: "Application",
    type: "link",
    iconUrl: "assets/images/ic_merchant.svg",
    iconUrlActive: "assets/images/ic_merchant_active.svg",
  },
];

@Injectable()
export class MenuItems {
  userData: any;
  constructor(private commonService: CommonService) {
    this.userData = this.commonService.getUser();

    this.getMenuitem();
  }

  getMenuitem(): Menu[] {
    if (this.userData.role == "admin") {
      return MENUITEMS;
    }
    if (this.userData.role == "manager") {
      return MENUITEMSMANAGER;
    }
    if (this.userData.role == "school") {
      return MENUITEMSCHOOL;
    }

    const menuItems = MENUITEMS;
    return menuItems;
  }
}
